import ChallengeStickerTable from './ChallengeStickerTable';

export default ChallengeStickerTable;
